// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GjCE","type":"styles_type__1GBxK","choices":"styles_choices__xen06"};